document.addEventListener('DOMContentLoaded', function () {
  var section = document.querySelector('[data-product-section]');
  if (!section) return;

  var galleryMain = section.querySelector('.product-gallery__main');
  var thumbsContainer = section.querySelector('.product-gallery__thumbs');
  var mainImage = section.querySelector('[data-product-main-image]');
  var thumbs = Array.prototype.slice.call(section.querySelectorAll('.product-gallery__thumb'));
  var prevBtn = section.querySelector('[data-gallery-prev]');
  var nextBtn = section.querySelector('[data-gallery-next]');
  var swatches = Array.prototype.slice.call(section.querySelectorAll('.product-swatch'));
  var pills = Array.prototype.slice.call(section.querySelectorAll('.product-pill'));
  var variantInput = section.querySelector('[data-variant-id-input]');
  var addButton = section.querySelector('[data-add-to-cart]');
  var form = section.querySelector('form[action="/cart/add"]');
  var priceNode = section.querySelector('[data-product-price]');
  var qtyInput = section.querySelector('[name="quantity"]');
  var qtyMinus = section.querySelector('[data-qty-minus]');
  var qtyPlus = section.querySelector('[data-qty-plus]');
  var note = section.querySelector('[data-product-note]');

  // Mobile carousel elements
  var slidesContainer = galleryMain ? galleryMain.querySelector('.product-gallery__slides') : null;
  var allSlides = slidesContainer ? Array.prototype.slice.call(slidesContainer.querySelectorAll('.product-gallery__slide:not(.product-gallery__slide--placeholder)')) : [];
  // slidePos tracks the actual translateX position (includes clone offset)
  // currentIndex stays as the logical image index (0 to images.length-1)
  var slidePos = 1; // starts at 1 because clone-of-last is at position 0
  var infiniteReady = false;

  function isMobileView() {
    return window.innerWidth <= 768;
  }

  var placeholderSlide = slidesContainer ? slidesContainer.querySelector('.product-gallery__slide--placeholder') : null;

  // Track which slides are visible after colour filtering
  function rebuildVisibleSlides(colorValue) {
    var normalised = (colorValue || '').trim().toLowerCase();
    allSlides.forEach(function (slide) {
      var slideColor = (slide.getAttribute('data-color') || '').trim().toLowerCase();
      var visible = !normalised || !slideColor || slideColor === normalised;
      slide.style.display = visible ? '' : 'none';
    });
  }

  // Remove old clones, create new ones from visible slides
  function setupInfiniteSlides() {
    if (!slidesContainer) return;
    // Remove existing clones
    slidesContainer.querySelectorAll('.product-gallery__slide--clone').forEach(function (el) {
      el.parentNode.removeChild(el);
    });
    infiniteReady = false;

    var visible = Array.prototype.slice.call(
      slidesContainer.querySelectorAll('.product-gallery__slide:not(.product-gallery__slide--placeholder):not(.product-gallery__slide--clone)')
    ).filter(function (s) {
      return s.style.display !== 'none';
    });

    if (visible.length < 2) return;

    // Clone last slide → prepend before first
    var cloneLast = visible[visible.length - 1].cloneNode(true);
    cloneLast.classList.add('product-gallery__slide--clone');
    cloneLast.removeAttribute('data-slide-image');
    slidesContainer.insertBefore(cloneLast, slidesContainer.firstChild);

    // Clone first slide → append after last
    var cloneFirst = visible[0].cloneNode(true);
    cloneFirst.classList.add('product-gallery__slide--clone');
    cloneFirst.removeAttribute('data-slide-image');
    slidesContainer.appendChild(cloneFirst);

    infiniteReady = true;
  }

  function slideTo(pos) {
    if (!slidesContainer) return;
    slidesContainer.style.transform = 'translateX(-' + (pos * 100) + '%)';
  }

  // After a clone transition ends, silently snap to the real slide
  function handleInfiniteSnap() {
    if (!infiniteReady || !slidesContainer) return;
    var len = images.length;
    if (len < 2) return;

    if (slidePos > len) {
      // We're on clone-of-first → snap to real first (position 1)
      slidePos = 1;
      currentIndex = 0;
      slidesContainer.style.transition = 'none';
      slideTo(slidePos);
      void slidesContainer.offsetHeight;
      slidesContainer.style.transition = 'transform 300ms cubic-bezier(0.25, 0.46, 0.45, 0.94)';
    } else if (slidePos < 1) {
      // We're on clone-of-last → snap to real last (position len)
      slidePos = len;
      currentIndex = len - 1;
      slidesContainer.style.transition = 'none';
      slideTo(slidePos);
      void slidesContainer.offsetHeight;
      slidesContainer.style.transition = 'transform 300ms cubic-bezier(0.25, 0.46, 0.45, 0.94)';
    }
  }

  function syncThumbsHeight() {
    if (!galleryMain || !thumbsContainer) return;
    var rect = galleryMain.getBoundingClientRect();
    if (rect.height > 0) {
      thumbsContainer.style.maxHeight = rect.height + 'px';
    }
  }

  // Zoom Lens Setup
  var lens = document.createElement('div');
  var zoomLevel = 2.5;
  var overNavArrow = false;
  var zoomImageReady = false;

  function getZoomSrc(src) {
    if (!src) return '';
    var base = src.replace(/[?&]width=\d+/, '');
    var join = base.indexOf('?') === -1 ? '?' : '&';
    return base + join + 'width=2000';
  }

  function preloadZoomImage(src) {
    zoomImageReady = false;
    lens.classList.remove('is-active');
    if (!src) return;
    var zoomSrc = getZoomSrc(src);
    var img = new Image();
    img.onload = function () {
      // Only apply if the main image still matches
      if (mainImage && getZoomSrc(mainImage.src) === zoomSrc) {
        lens.style.backgroundImage = 'url(' + zoomSrc + ')';
        zoomImageReady = true;
      }
    };
    img.src = zoomSrc;
  }

  if (galleryMain && lens) {
    lens.className = 'product-gallery__lens';
    galleryMain.appendChild(lens);

    // Preload zoom image once the main image has loaded
    if (mainImage) {
      if (mainImage.complete) {
        preloadZoomImage(mainImage.src);
      } else {
        mainImage.addEventListener('load', function () {
          preloadZoomImage(mainImage.src);
        }, { once: true });
      }
    }

    galleryMain.addEventListener('mouseenter', function () {
      if (overNavArrow) return;
      if (!zoomImageReady) return;
      if (isMobileView()) return;
      lens.classList.add('is-active');
    });

    galleryMain.addEventListener('mouseleave', function () {
      lens.classList.remove('is-active');
    });

    galleryMain.addEventListener('mousemove', function (e) {
      if (overNavArrow) {
        lens.classList.remove('is-active');
        return;
      }

      if (!zoomImageReady) return;

      // If we re-enter after hovering a nav arrow, reactivate the lens
      if (!lens.classList.contains('is-active')) {
        lens.classList.add('is-active');
      }

      var rect = galleryMain.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var y = e.clientY - rect.top;

      // Lens position
      var lx = x - (lens.offsetWidth / 2);
      var ly = y - (lens.offsetHeight / 2);
      lens.style.left = lx + 'px';
      lens.style.top = ly + 'px';

      // Background position
      var bgX = (lens.offsetWidth / 2) - (x * zoomLevel);
      var bgY = (lens.offsetHeight / 2) - (y * zoomLevel);
      
      lens.style.backgroundSize = (rect.width * zoomLevel) + 'px ' + (rect.height * zoomLevel) + 'px';
      lens.style.backgroundPosition = bgX + 'px ' + bgY + 'px';
    });

    // Disable zoom when hovering the navigation arrows
    ['mouseenter', 'mouseleave'].forEach(function (evtName) {
      [prevBtn, nextBtn].forEach(function (btn) {
        if (!btn) return;
        btn.addEventListener(evtName, function () {
          overNavArrow = evtName === 'mouseenter';
          if (overNavArrow) {
            lens.classList.remove('is-active');
          }
        });
      });
    });
  }

  var images = thumbs
    .map(function (btn) {
      return btn.getAttribute('data-image') || '';
    })
    .filter(function (src) {
      return !!src;
    });
  var currentIndex = 0;
  if (mainImage && mainImage.getAttribute('src')) {
    var initSrc = mainImage.getAttribute('src');
    var initIdx = images.indexOf(initSrc);
    if (initIdx !== -1) currentIndex = initIdx;
  }

  syncThumbsHeight();
  if (mainImage) {
    mainImage.addEventListener('load', syncThumbsHeight);
  }
  window.addEventListener('resize', syncThumbsHeight);

  function parseJSON(selector) {
    var el = section.querySelector(selector);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || el.innerText || 'null');
    } catch (e) {
      return null;
    }
  }

  var variants = parseJSON('[data-product-variants]') || [];
  var positions = parseJSON('[data-product-option-positions]') || {};

  var selected = {};
  // Cache live inventory per variant (align with cart drawer behaviour)
  var inventoryCache = {};
  var inventoryInflight = {};

  function fetchVariantInventory(variantId) {
    var id = Number(variantId);
    if (!id) return Promise.resolve(null);

    if (Object.prototype.hasOwnProperty.call(inventoryCache, id)) {
      return Promise.resolve(inventoryCache[id]);
    }
    if (inventoryInflight[id]) return inventoryInflight[id];

    var p = fetch('/variants/' + id + '.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('variant fetch failed');
        return res.json();
      })
      .then(function (data) {
        var qty = data && typeof data.inventory_quantity === 'number' ? data.inventory_quantity : null;
        inventoryCache[id] = qty;
        return qty;
      })
      .catch(function () {
        inventoryCache[id] = null;
        return null;
      })
      .finally(function () {
        delete inventoryInflight[id];
      });

    inventoryInflight[id] = p;
    return p;
  }

  function setSelected(optionPos, value) {
    selected[optionPos] = value;
  }

  function buildArrow(direction) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'product-gallery__arrow product-gallery__arrow--' + direction;
    btn.setAttribute('aria-label', direction === 'prev' ? 'Previous image' : 'Next image');
    btn.dataset[direction === 'prev' ? 'galleryPrev' : 'galleryNext'] = '';
    btn.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
      (direction === 'prev'
        ? '<path d="M9.75 3.5 5.25 8l4.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>'
        : '<path d="m6.25 3.5 4.5 4.5-4.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>') +
      '</svg>';
    return btn;
  }

  function ensureArrows() {
    if (!galleryMain) return;
    if (!prevBtn) {
      prevBtn = buildArrow('prev');
      galleryMain.appendChild(prevBtn);
    }
    if (!nextBtn) {
      nextBtn = buildArrow('next');
      galleryMain.appendChild(nextBtn);
    }
  }

  function getOpt(v, pos) {
    if (!pos) return '';
    if (pos === 1) return v.option1 || '';
    if (pos === 2) return v.option2 || '';
    if (pos === 3) return v.option3 || '';
    return '';
  }

  function findVariant() {
    return variants.find(function (v) {
      var o1 = positions.option1 || 1;
      var o2 = positions.option2 || 2;
      var o3 = positions.option3 || 3;
      if (selected[o1] && v.option1 !== selected[o1]) return false;
      if (selected[o2] && v.option2 !== selected[o2]) return false;
      if (selected[o3] && v.option3 !== selected[o3]) return false;
      return true;
    });
  }

  function isSellable(v) {
    if (!v) return false;
    // Trust Shopify's own availability flag. It already accounts for inventory
    // policy AND the online quantity across every location that fulfils online
    // orders (incl. JIT / fulfilment-service locations). We must NOT override it
    // with inventory_quantity, which can read 0 for stock held at those locations
    // even while the variant is genuinely available — that was hiding in-stock items.
    return v.available === true;
  }

  function swatchHasAnyStock(swatchValue, swatchPos) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (!isSellable(v)) continue;
      if (getOpt(v, swatchPos) === swatchValue) return true;
    }
    return false;
  }

  function getAvailableOptionsForSwatch(swatchValue, swatchPos, targetPos) {
    var set = {};
    if (!swatchPos || !targetPos) return set;
    variants.forEach(function (v) {
      if (!isSellable(v)) return;
      if (getOpt(v, swatchPos) !== swatchValue) return;
      set[getOpt(v, targetPos)] = true;
    });
    return set;
  }

  function updatePrice(variant) {
    if (!priceNode || !variant) return;
    var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
    var isFinalSale = section.hasAttribute('data-final-sale');
    var isNew = section.hasAttribute('data-new-product');
    var priceHTML = '';

    function fmt(cents) {
      return typeof Shopify !== 'undefined' && Shopify.formatMoney
        ? Shopify.formatMoney(cents, Shopify.money_format || '£{{amount}}')
        : '£' + (cents / 100).toFixed(2);
    }

    // Determine badge: Final Sale > Sale > New
    var isGardiners = section.hasAttribute('data-gardiners');
    var badgeHTML = '';
    if (isFinalSale) {
      badgeHTML = '<span class="price__badge price__badge--final-sale">Final Sale</span>';
    } else if (hasCompare) {
      badgeHTML = '<span class="price__badge price__badge--sale">Sale</span>';
    } else if (isNew) {
      badgeHTML = '<span class="price__badge price__badge--new">New</span>';
    }

    // Online Exclusive (Gardiners direct-ship range) — shows in addition to any other badge
    if (isGardiners) {
      badgeHTML += '<span class="price__badge price__badge--online-exclusive">Online Exclusive</span>';
    }

    // Update standalone badge above title
    var standaloneBadge = section.querySelector('[data-product-badge]');
    if (standaloneBadge) {
      standaloneBadge.innerHTML = badgeHTML;
    }

    // "You Save" line
    var savingHTML = '';
    if (hasCompare) {
      var savingAmount = variant.compare_at_price - variant.price;
      var savingPercent = Math.round((savingAmount / variant.compare_at_price) * 100);
      savingHTML = '<span class="price__saving">You Save ' + fmt(savingAmount) + ' (' + savingPercent + '%)</span>';
    }

    if (hasCompare) {
      priceHTML = '<div class="price price--on-sale">' +
        badgeHTML +
        '<s class="price__compare">' + fmt(variant.compare_at_price) + '</s>' +
        '<span class="price__current">' + fmt(variant.price) + '</span>' +
        savingHTML +
        '</div>';
    } else {
      priceHTML = '<div class="price">' +
        badgeHTML +
        '<span class="price__current">' + fmt(variant.price) + '</span>' +
        '</div>';
    }

    priceNode.innerHTML = priceHTML;
  }

  function updateMainImage(src) {
    if (!mainImage || !src) return;

    // Derive the base URL (strip any existing ?width= param)
    var base = src.replace(/[?&]width=\d+/, '');
    var join = base.indexOf('?') === -1 ? '?' : '&';
    var newSrcset = [400, 800, 1200].map(function (w) {
      return base + join + 'width=' + w + ' ' + w + 'w';
    }).join(', ');

    mainImage.setAttribute('src', src);
    mainImage.setAttribute('srcset', newSrcset);
    mainImage.setAttribute('sizes', '(max-width: 749px) 100vw, 50vw');

    if (lens) {
      preloadZoomImage(mainImage.src);
    }
    var idx = images.indexOf(src);
    if (idx !== -1) currentIndex = idx;
    updateThumbActive(src);
  }

  function updateThumbActive(src) {
    thumbs.forEach(function (btn) {
      var img = btn.getAttribute('data-image');
      var isMatch = img === src;
      btn.classList.toggle('is-active', isMatch);
      if (isMatch && thumbsContainer) {
        btn.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    });
  }

  function goToIndex(idx) {
    if (!images.length) return;
    var len = images.length;
    var nextIndex = ((idx % len) + len) % len;
    currentIndex = nextIndex;
    var src = images[nextIndex];
    updateMainImage(src);
    updateThumbActive(src);
  }
  function updateArrowsState() {
    var hasSlides = images.length > 1;
    if (prevBtn) prevBtn.disabled = !hasSlides;
    if (nextBtn) nextBtn.disabled = !hasSlides;
  }

  // Filter gallery images by colour (based on data-color attribute from image alt text)
  function filterGalleryByColor(colorValue) {
    if (!thumbsContainer) return;
    var allThumbs = Array.prototype.slice.call(thumbsContainer.querySelectorAll('.product-gallery__thumb'));
    var hasColorData = allThumbs.some(function (btn) {
      return btn.hasAttribute('data-color');
    });

    // If no thumbs have data-color, still update slides for mobile placeholder
    if (!hasColorData) {
      rebuildVisibleSlides(colorValue);
      var visSlides = allSlides.filter(function (s) { return s.style.display !== 'none'; }).length;
      if (placeholderSlide) {
        placeholderSlide.style.display = visSlides === 0 ? '' : 'none';
      }
      setupInfiniteSlides();
      slidePos = visSlides > 0 ? 1 : 0;
      if (slidesContainer) {
        slidesContainer.style.transition = 'none';
        slideTo(slidePos);
        void slidesContainer.offsetHeight;
        slidesContainer.style.transition = 'transform 300ms cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      }
      return;
    }

    var normalised = (colorValue || '').trim().toLowerCase();

    allThumbs.forEach(function (btn) {
      var thumbColor = (btn.getAttribute('data-color') || '').trim().toLowerCase();
      // Show if colour matches OR if thumb has no colour tag (generic/lifestyle images)
      var visible = !normalised || !thumbColor || thumbColor === normalised;
      btn.style.display = visible ? '' : 'none';
    });

    // Rebuild the images array and thumbs reference from visible thumbs only
    var visibleThumbs = allThumbs.filter(function (btn) {
      return btn.style.display !== 'none';
    });
    thumbs = visibleThumbs;
    images = visibleThumbs.map(function (btn) {
      return btn.getAttribute('data-image') || '';
    }).filter(function (src) {
      return !!src;
    });

    // Jump to the first visible image
    if (images.length > 0) {
      currentIndex = 0;
      updateMainImage(images[0]);
      updateThumbActive(images[0]);
    }

    // Rebuild mobile dots
    if (dotsContainer && dotsContainer.parentNode) {
      dotsContainer.parentNode.removeChild(dotsContainer);
      dotsContainer = null;
    }
    if (galleryMain && images.length > 1) {
      dotsContainer = document.createElement('div');
      dotsContainer.className = 'product-gallery__dots';
      images.forEach(function (_, i) {
        var dot = document.createElement('span');
        dot.className = 'product-gallery__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('data-dot-index', i);
        dotsContainer.appendChild(dot);
      });
      galleryMain.appendChild(dotsContainer);
    }

    // Also filter mobile carousel slides and rebuild infinite clones
    rebuildVisibleSlides(colorValue);
    // Check if any real slides are visible after filtering
    var visibleSlideCount = allSlides.filter(function (s) {
      return s.style.display !== 'none';
    }).length;
    if (placeholderSlide) {
      placeholderSlide.style.display = visibleSlideCount === 0 ? '' : 'none';
    }
    setupInfiniteSlides();
    slidePos = visibleSlideCount > 0 ? 1 : 0;
    if (slidesContainer) {
      slidesContainer.style.transition = 'none';
      slideTo(slidePos);
      void slidesContainer.offsetHeight;
      slidesContainer.style.transition = 'transform 300ms cubic-bezier(0.25, 0.46, 0.45, 0.94)';
    }

    updateArrowsState();
    syncThumbsHeight();
  }

  // ---- Cart helpers (aligned with quick view) ----
  function dispatchCartEvents(detail) {
    try {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: detail || {} }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: detail || {} }));
      document.dispatchEvent(new CustomEvent('cart:open', { detail: detail || {} }));
    } catch (e) {}
  }

  async function refreshCartCountBestEffort() {
    try {
      var res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) return;
      var cart = await res.json();
      var nodes = []
        .concat(Array.prototype.slice.call(document.querySelectorAll('[data-cart-count]')))
        .concat(Array.prototype.slice.call(document.querySelectorAll('[data-cart-count-badge]')))
        .concat(Array.prototype.slice.call(document.querySelectorAll('.cart-count')))
        .concat(Array.prototype.slice.call(document.querySelectorAll('.cart-count-badge')));
      nodes.forEach(function (el) {
        el.textContent = String(cart.item_count || 0);
      });
    } catch (e) {}
  }

  function openCartDrawerBestEffort() {
    try {
      if (window.CartAPI && typeof window.CartAPI.openDrawer === 'function') {
        window.CartAPI.openDrawer();
        return;
      }
      if (window.CartDrawer && typeof window.CartDrawer.open === 'function') {
        window.CartDrawer.open();
        return;
      }
      if (window.cartDrawer && typeof window.cartDrawer.open === 'function') {
        window.cartDrawer.open();
        return;
      }
    } catch (e) {}
    dispatchCartEvents({ source: 'product-page' });
  }

  function updateAvailability(variant) {
    if (!addButton || !variantInput) return;
    var maxQty = null;
    if (variant) {
      var parsed = Number(variant.inventory_quantity);
      if (!isNaN(parsed) && parsed > 0) {
        maxQty = parsed;
      } else if (Object.prototype.hasOwnProperty.call(inventoryCache, variant.id) && typeof inventoryCache[variant.id] === 'number' && inventoryCache[variant.id] > 0) {
        maxQty = inventoryCache[variant.id];
      } else if (variant.available) {
        // Available but no reliable positive count — e.g. stock sits at a JIT /
        // fulfilment-service location that isn't reflected in inventory_quantity.
        // Trust availability and don't cap; Shopify enforces real limits at checkout.
        maxQty = null;
        if (qtyInput) qtyInput.removeAttribute('max');
      } else {
        // Quantity unknown and availability not confirmed — cap at 1 until live inventory arrives
        if (qtyInput) {
          qtyInput.max = '1';
          qtyInput.setAttribute('max', '1');
        }
        fetchVariantInventory(variant.id).then(function (qty) {
          if (!qtyInput || !variantInput) return;
          if (variantInput.value !== String(variant.id)) return; // stale response
          if (typeof qty === 'number' && qty > 0) {
            var maxVal = String(qty);
            qtyInput.max = maxVal;
            qtyInput.setAttribute('max', maxVal);
            enforceQuantityLimit(qty, false);
          } else {
            qtyInput.removeAttribute('max');
          }
        });
      }
    }
    if (qtyInput) {
      if (typeof maxQty === 'number') {
        var maxVal = String(Math.max(0, maxQty));
        qtyInput.max = maxVal;
        qtyInput.setAttribute('max', maxVal);
      } else {
        qtyInput.removeAttribute('max');
      }
    }

    if (variant && isSellable(variant)) {
      addButton.disabled = false;
      addButton.textContent = 'Add to bag';
      variantInput.value = variant.id;
    } else if (variant) {
      addButton.disabled = true;
      addButton.textContent = 'Sold out';
      variantInput.value = variant.id;
    } else {
      addButton.disabled = true;
      addButton.textContent = 'Sold out';
    }

    enforceQuantityLimit(maxQty, true);
  }

  function setNote(msg) {
    if (!note) return;
    var hasMsg = !!msg;
    note.textContent = msg || '';
    note.classList.toggle('is-visible', hasMsg);
  }

  function isShortageNoteActive() {
    if (!note) return false;
    var txt = note.textContent || '';
    return txt.indexOf("Sorry, we don't have that many available right now.") === 0;
  }

  function enforceQuantityLimit(maxQty, allowMessage) {
    if (!qtyInput) return { value: null, clamped: false };
    var val = Number(qtyInput.value || 1);
    if (isNaN(val) || val < 1) val = 1;
    var max = typeof maxQty === 'number' ? maxQty : null;
    if (max !== null && max < 1) max = 1;
    var clamped = false;
    if (max !== null && val > max) {
      val = max;
      clamped = true;
      if (allowMessage) {
        setNote("Sorry, we don't have that many available right now.");
      }
    }
    qtyInput.value = String(val);
    return { value: val, clamped: clamped };
  }

  function getCurrentVariantMax() {
    var variant = findVariant();
    if (!variant) return null;
    var qty = Number(variant.inventory_quantity);
    if (!isNaN(qty) && qty > 0) return qty;
    var cached = inventoryCache[variant.id];
    if (typeof cached === 'number' && cached > 0) return cached;
    // 0 / unknown — no reliable positive cap (e.g. JIT location stock). Don't clamp.
    return null;
  }

  function clampToLiveMax(allowMessage) {
    if (!variantInput || !qtyInput) return Promise.resolve(null);
    var variantId = Number(variantInput.value || 0);
    if (!variantId) return Promise.resolve(null);
    return fetchVariantInventory(variantId).then(function (qty) {
      if (typeof qty === 'number') {
        var maxVal = String(Math.max(0, qty));
        qtyInput.max = maxVal;
        qtyInput.setAttribute('max', maxVal);
        enforceQuantityLimit(qty, !!allowMessage);
        return qty;
      } else {
        qtyInput.removeAttribute('max');
        return null;
      }
    });
  }

  function ensureCurrentVariantMax() {
    var variant = findVariant();
    if (!variant) return Promise.resolve(null);
    var current = getCurrentVariantMax();
    if (typeof current === 'number') return Promise.resolve(current);
    return fetchVariantInventory(variant.id).then(function (qty) {
      if (typeof qty === 'number') {
        inventoryCache[variant.id] = qty;
        if (qtyInput && variantInput && variantInput.value === String(variant.id)) {
          var maxVal = String(Math.max(0, qty));
          qtyInput.max = maxVal;
          qtyInput.setAttribute('max', maxVal);
        }
        return Math.max(0, qty);
      }
      return null;
    });
  }

  function bumpQuantity(delta, allowMessage, maxOverride) {
    if (!qtyInput) return;
    var current = Number(qtyInput.value || 1);
    if (isNaN(current)) current = 1;
    current = Math.max(1, current + delta);
    qtyInput.value = String(current);
    var max = typeof maxOverride === 'number'
      ? maxOverride
      : qtyInput.hasAttribute('max')
        ? Number(qtyInput.getAttribute('max'))
        : getCurrentVariantMax();
    enforceQuantityLimit(max, allowMessage);
  }

  function updateSwatchesDisabledState() {
    swatches.forEach(function (btn) {
      var pos = Number(btn.getAttribute('data-option-position'));
      var value = btn.getAttribute('data-option-value') || '';
      var hasStock = swatchHasAnyStock(value, pos);

      btn.classList.toggle('is-disabled', !hasStock);
      if (!hasStock) {
        btn.setAttribute('tabindex', '-1');
      } else {
        btn.removeAttribute('tabindex');
      }
    });
  }

  function updatePillsDisabledState() {
    var optionPositions = pills
      .map(function (btn) {
        return Number(btn.getAttribute('data-option-position'));
      })
      .filter(function (p) {
        return !isNaN(p);
      });

    pills.forEach(function (btn) {
      var pos = Number(btn.getAttribute('data-option-position'));
      var value = btn.getAttribute('data-option-value') || '';

      // Require all lower-numbered option positions to be selected first
      var unmetPrereq = optionPositions.some(function (p) {
        return p < pos && !selected[p];
      });
      if (unmetPrereq) {
        btn.disabled = true;
        btn.classList.add('is-disabled');
        return;
      }

      var hasStock = variants.some(function (v) {
        if (!isSellable(v)) return false;
        if (getOpt(v, pos) !== value) return false;

        // All other selected options must match
        for (var p in selected) {
          var selectedPos = Number(p);
          var selectedVal = selected[p];
          if (!selectedVal) continue;
          if (selectedPos === pos) continue;
          if (getOpt(v, selectedPos) !== selectedVal) return false;
        }

        return true;
      });

      btn.disabled = !hasStock;
      btn.classList.toggle('is-disabled', !hasStock);

      if (!hasStock && btn.classList.contains('is-selected')) {
        btn.classList.remove('is-selected');
        selected[pos] = '';
      }
    });
  }

  function handleSelectionChange() {
    // Default to disabled - only enable when all conditions are met
    if (qtyInput) {
      qtyInput.disabled = true;
      qtyInput.style.pointerEvents = 'none';
      qtyInput.style.opacity = '0.6';
    }
    if (qtyMinus) {
      qtyMinus.disabled = true;
      qtyMinus.style.pointerEvents = 'none';
      qtyMinus.style.opacity = '0.5';
    }
    if (qtyPlus) {
      qtyPlus.disabled = true;
      qtyPlus.style.pointerEvents = 'none';
      qtyPlus.style.opacity = '0.5';
    }
    if (addButton) addButton.disabled = true;
    
    var requireColor = swatches.length > 0;
    var hasColorSelected = swatches.some(function (btn) {
      return btn.classList.contains('is-selected');
    });

    var pillPositions = pills
      .map(function (btn) {
        return Number(btn.getAttribute('data-option-position'));
      })
      .filter(function (p) {
        return !isNaN(p);
      })
      .filter(function (value, index, self) {
        return self.indexOf(value) === index;
      });

    var missingPos = pillPositions.find(function (p) {
      return !selected[p];
    });

    function disablePurchase(msg) {
      if (addButton) addButton.disabled = true;
      if (qtyInput) qtyInput.disabled = true;
      if (variantInput) variantInput.value = '';
      setNote(msg);
    }

    if (requireColor && !hasColorSelected) {
      disablePurchase('Select a colour.');
      updatePillsDisabledState();
      return;
    }

    // Update price as soon as we can find a matching variant (even before all options selected)
    var variant = findVariant();
    if (variant) {
      updatePrice(variant);
    }

    if (pillPositions.length && typeof missingPos !== 'undefined') {
      var missingMsg = 'Select a size.';
      if (pillPositions.length > 1 && missingPos === pillPositions[0]) {
        missingMsg = 'Select a fit.';
      }
      disablePurchase(missingMsg);
      updatePillsDisabledState();
      return;
    }

    if (variant) {
      updateAvailability(variant);
      
      // Check if all options are selected
      var allOptionsSelected = pillPositions.every(function(p) {
        return selected[p];
      });
      
      // Only enable if variant is sellable AND all required options are selected
      if (!allOptionsSelected) {
        // This shouldn't normally happen as we check for missing options above,
        // but as a safety net, disable purchase
        if (qtyInput) qtyInput.disabled = true;
      } else if (isSellable(variant)) {
        // Clear any messages when all options selected and variant available
        setNote('');
        if (qtyInput) {
          qtyInput.disabled = false;
          qtyInput.style.pointerEvents = 'auto';
          qtyInput.style.opacity = '1';
        }
        if (qtyMinus) {
          qtyMinus.disabled = false;
          qtyMinus.style.pointerEvents = 'auto';
          qtyMinus.style.opacity = '1';
        }
        if (qtyPlus) {
          qtyPlus.disabled = false;
          qtyPlus.style.pointerEvents = 'auto';
          qtyPlus.style.opacity = '1';
        }
      } else {
        setNote('This option is out of stock.');
        if (qtyInput) qtyInput.disabled = true;
      }
    } else {
      disablePurchase('Select options to see availability.');
    }

    updatePillsDisabledState();
  }

  // Swatches
  swatches.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.classList.contains('is-disabled')) return;
      var pos = Number(btn.getAttribute('data-option-position'));
      var value = btn.getAttribute('data-option-value') || '';
      swatches
        .filter(function (b) {
          return Number(b.getAttribute('data-option-position')) === pos;
        })
        .forEach(function (b) {
          b.classList.remove('is-selected');
        });
      btn.classList.add('is-selected');
      setSelected(pos, value);

      // Update colour name label
      var colorLabel = section.querySelector('[data-selected-color]');
      if (colorLabel) colorLabel.textContent = value;

      // Clear all pill selections when color changes
      pills.forEach(function (p) {
        p.classList.remove('is-selected');
        var pPos = Number(p.getAttribute('data-option-position'));
        delete selected[pPos];
      });

      // Filter gallery to show only images matching the selected colour
      filterGalleryByColor(value);
      updatePillsDisabledState();

      // Auto-select fit if only one enabled fit option exists
      var pillPositions = [];
      pills.forEach(function (p) {
        var pp = Number(p.getAttribute('data-option-position'));
        if (pillPositions.indexOf(pp) === -1) pillPositions.push(pp);
      });
      pillPositions.sort();
      if (pillPositions.length > 1) {
        var fitPos = pillPositions[0];
        var enabledFits = pills.filter(function (p) {
          return Number(p.getAttribute('data-option-position')) === fitPos && !p.disabled;
        });
        if (enabledFits.length === 1) {
          enabledFits[0].classList.add('is-selected');
          setSelected(fitPos, enabledFits[0].getAttribute('data-option-value') || '');
          updatePillsDisabledState();
        }
      }

      handleSelectionChange();
    });
  });

  // Size/fit pills
  pills.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled || btn.classList.contains('is-disabled')) return;
      var pos = Number(btn.getAttribute('data-option-position'));
      var value = btn.getAttribute('data-option-value') || '';

      pills
        .filter(function (b) {
          return Number(b.getAttribute('data-option-position')) === pos;
        })
        .forEach(function (b) {
          b.classList.remove('is-selected');
        });
      btn.classList.add('is-selected');
      setSelected(pos, value);
      updatePillsDisabledState();
      handleSelectionChange();
    });
  });

  // Thumbnails
  thumbs.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var img = btn.getAttribute('data-image');
      if (!img) return;
      var idx = images.indexOf(img);
      if (idx !== -1) currentIndex = idx;
      updateMainImage(img);
      updateThumbActive(img);

      // Sync options if image belongs to a variant
      var matchingVariant = variants.find(function (v) {
        return v.featured_image && v.featured_image.src === img;
      });

      if (matchingVariant) {
        if (matchingVariant.option1) setSelected(1, matchingVariant.option1);
        if (matchingVariant.option2) setSelected(2, matchingVariant.option2);
        if (matchingVariant.option3) setSelected(3, matchingVariant.option3);

        swatches.concat(pills).forEach(function (btn) {
          var pos = Number(btn.getAttribute('data-option-position'));
          var val = btn.getAttribute('data-option-value');
          btn.classList.toggle('is-selected', selected[pos] === val);
        });

        updateSwatchesDisabledState();
        updatePillsDisabledState();
        handleSelectionChange();
      }
    });
  });

  ensureArrows();

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      goToIndex(currentIndex - 1);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      goToIndex(currentIndex + 1);
    });
  }

  // ---- Mobile swipe support (drag-feedback carousel) ----
  (function () {
    if (!galleryMain) return;
    var startX = 0;
    var startY = 0;
    var tracking = false;
    var directionLocked = false;
    var isHorizontal = false;
    var dragOffset = 0;

    galleryMain.addEventListener('touchstart', function (e) {
      if (images.length < 2) return;
      var t = e.touches[0];
      startX = t.clientX;
      startY = t.clientY;
      tracking = true;
      directionLocked = false;
      isHorizontal = false;
      dragOffset = 0;
      // Remove transition during drag for immediate finger-tracking
      if (isMobileView() && slidesContainer) {
        slidesContainer.style.transition = 'none';
      }
    }, { passive: true });

    galleryMain.addEventListener('touchmove', function (e) {
      if (!tracking) return;
      var t = e.touches[0];
      var dx = t.clientX - startX;
      var dy = Math.abs(t.clientY - startY);
      if (!directionLocked && (Math.abs(dx) > 8 || dy > 8)) {
        directionLocked = true;
        isHorizontal = Math.abs(dx) > dy;
      }
      if (directionLocked && isHorizontal) {
        e.preventDefault();
        dragOffset = dx;
        // Real-time drag: move the slides container with the finger
        if (isMobileView() && slidesContainer) {
          var baseOffset = -(slidePos * 100);
          var containerWidth = galleryMain.getBoundingClientRect().width;
          var pxToPercent = (dragOffset / containerWidth) * 100;
          slidesContainer.style.transform = 'translateX(' + (baseOffset + pxToPercent) + '%)';
        }
      }
    }, { passive: false });

    galleryMain.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      // Restore transition for snap animation
      if (isMobileView() && slidesContainer) {
        slidesContainer.style.transition = 'transform 300ms cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      }
      if (!isHorizontal) return;
      if (Math.abs(dragOffset) > 30) {
        if (dragOffset < 0) goToIndex(currentIndex + 1);
        else goToIndex(currentIndex - 1);
      } else {
        // Snap back to current slide
        goToIndex(currentIndex);
      }
    }, { passive: true });
  })();

  // ---- Dot indicators (mobile) ----
  var dotsContainer = null;
  (function () {
    if (!galleryMain || images.length < 2) return;
    dotsContainer = document.createElement('div');
    dotsContainer.className = 'product-gallery__dots';
    images.forEach(function (_, i) {
      var dot = document.createElement('span');
      dot.className = 'product-gallery__dot' + (i === currentIndex ? ' is-active' : '');
      dot.setAttribute('data-dot-index', i);
      dotsContainer.appendChild(dot);
    });
    galleryMain.appendChild(dotsContainer);
  })();

  // Listen for transition end to handle infinite loop snapping
  if (slidesContainer) {
    slidesContainer.addEventListener('transitionend', function (e) {
      if (e.target !== slidesContainer) return;
      handleInfiniteSnap();
      // Update dots after snap
      if (dotsContainer) {
        var dots = dotsContainer.children;
        for (var i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('is-active', i === currentIndex);
        }
      }
    });
  }

  // Patch goToIndex to update dots + drive mobile carousel
  var _origGoToIndex = goToIndex;
  goToIndex = function (idx) {
    if (isMobileView() && infiniteReady) {
      // Infinite carousel: allow slidePos to go to clones (0 or len+1)
      var len = images.length;
      if (idx < 0) {
        // Going before first → move to clone-of-last at position 0
        slidePos = 0;
        currentIndex = len - 1;
      } else if (idx >= len) {
        // Going past last → move to clone-of-first at position len+1
        slidePos = len + 1;
        currentIndex = 0;
      } else {
        slidePos = idx + 1; // +1 because clone-of-last is at position 0
        currentIndex = idx;
      }
      slideTo(slidePos);
      // Update the desktop main image too (keeps it in sync)
      var src = images[currentIndex];
      if (src) {
        updateMainImage(src);
        updateThumbActive(src);
      }
    } else {
      _origGoToIndex(idx);
      if (isMobileView()) {
        slidePos = infiniteReady ? (currentIndex + 1) : currentIndex;
        slideTo(slidePos);
      }
    }
    // Update dot indicators
    if (dotsContainer) {
      var dots = dotsContainer.children;
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === currentIndex);
      }
    }
  };

  // Default selections: mark any preselected buttons
  swatches.forEach(function (btn) {
    if (btn.classList.contains('is-selected')) {
      var pos = Number(btn.getAttribute('data-option-position'));
      var value = btn.getAttribute('data-option-value') || '';
      setSelected(pos, value);
    }
  });
  pills.forEach(function (btn) {
    if (btn.classList.contains('is-selected')) {
      var pos = Number(btn.getAttribute('data-option-position'));
      var value = btn.getAttribute('data-option-value') || '';
      setSelected(pos, value);
    }
  });

  updateSwatchesDisabledState();
  updatePillsDisabledState();
  handleSelectionChange();
  updateArrowsState();

  // Filter gallery on initial load if a colour is pre-selected
  var preselectedSwatch = swatches.find(function (btn) {
    return btn.classList.contains('is-selected');
  });
  if (preselectedSwatch) {
    var preselectedColor = preselectedSwatch.getAttribute('data-option-value') || '';
    if (preselectedColor) filterGalleryByColor(preselectedColor);
  } else {
    rebuildVisibleSlides('');
    setupInfiniteSlides();
  }

  // Set initial slide position on mobile (slidePos=1 because clone-of-last is at 0)
  // If infinite clones weren't created (fewer than 2 slides), slidePos should equal currentIndex directly
  slidePos = infiniteReady ? (currentIndex + 1) : currentIndex;
  if (isMobileView() && slidesContainer) {
    slidesContainer.style.transition = 'none';
    slideTo(slidePos);
    void slidesContainer.offsetHeight;
    slidesContainer.style.transition = 'transform 300ms cubic-bezier(0.25, 0.46, 0.45, 0.94)';
  }

  // Reset carousel transform on device rotation / resize to desktop
  window.addEventListener('resize', function () {
    if (!isMobileView() && slidesContainer) {
      slidesContainer.style.transform = '';
    } else if (isMobileView() && slidesContainer) {
      // Don't override slidePos when placeholder is showing (slidePos = 0)
      var hasVisibleSlides = allSlides.some(function (s) { return s.style.display !== 'none'; });
      if (hasVisibleSlides) {
        slidePos = infiniteReady ? (currentIndex + 1) : currentIndex;
      }
      slideTo(slidePos);
    }
  });

  // Quantity clamp
  if (qtyInput) {
    qtyInput.setAttribute('autocomplete', 'off');
    qtyInput.setAttribute('min', '1');
    qtyInput.setAttribute('type', 'number');
    qtyInput.setAttribute('pattern', '[0-9]*');
    qtyInput.setAttribute('inputmode', 'numeric');

    // Prevent typing non-numeric characters and enforce max on keydown
    qtyInput.addEventListener('keydown', function (e) {
      // Allow: backspace, delete, tab, escape, enter
      if ([8, 9, 27, 13, 46].indexOf(e.keyCode) !== -1 ||
        // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
        (e.keyCode === 65 && e.ctrlKey === true) ||
        (e.keyCode === 67 && e.ctrlKey === true) ||
        (e.keyCode === 86 && e.ctrlKey === true) ||
        (e.keyCode === 88 && e.ctrlKey === true) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)) {
        return;
      }

      // Prevent up arrow if at max
      if (e.keyCode === 38) {
        var currentVal = Number(qtyInput.value || 1);
        var maxAttr = qtyInput.hasAttribute('max') ? Number(qtyInput.getAttribute('max')) : null;
        if (maxAttr !== null && currentVal >= maxAttr) {
          e.preventDefault();
          setNote("Sorry, we don't have that many available right now.");
          return;
        }
      }

      // Prevent down arrow if at 1
      if (e.keyCode === 40) {
        var currentVal = Number(qtyInput.value || 1);
        if (currentVal <= 1) {
          e.preventDefault();
          return;
        }
      }

      // Ensure it's a number
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
      }
    });

    var inputTimer = null;
    qtyInput.addEventListener('input', function () {
      if (qtyInput.disabled) return;
      
      // Clear any pending timer
      if (inputTimer) clearTimeout(inputTimer);

      // Remove any non-numeric characters
      var cleaned = qtyInput.value.replace(/[^0-9]/g, '');
      if (cleaned !== qtyInput.value) {
        qtyInput.value = cleaned;
      }

      // Get the max limit
      var maxAttr = qtyInput.hasAttribute('max') ? Number(qtyInput.getAttribute('max')) : getCurrentVariantMax();

      // Enforce immediately on input - HARD LIMIT
      var currentVal = Number(qtyInput.value);
      if (!isNaN(currentVal) && currentVal > 0 && typeof maxAttr === 'number' && !isNaN(maxAttr)) {
        if (currentVal > maxAttr) {
          qtyInput.value = String(maxAttr);
          setNote("Sorry, we don't have that many available right now.");
          return;
        } else if (isShortageNoteActive()) {
          // Clear the shortage note if quantity is now valid
          setNote('');
        }
      }

      // Also schedule a check for slightly delayed events
      inputTimer = setTimeout(function() {
        var max = qtyInput.hasAttribute('max') ? Number(qtyInput.getAttribute('max')) : getCurrentVariantMax();
        if (typeof max === 'number' && !isNaN(max)) {
          var result = enforceQuantityLimit(max, true);
          if (result && !result.clamped && isShortageNoteActive()) {
            setNote('');
          }
        } else {
          clampToLiveMax(true);
        }
      }, 50);
    });

    qtyInput.addEventListener('change', function () {
      if (qtyInput.disabled) return;
      var maxAttr = qtyInput.hasAttribute('max') ? Number(qtyInput.getAttribute('max')) : getCurrentVariantMax();
      var maxKnown = typeof maxAttr === 'number' && !isNaN(maxAttr);
      var maybeClamp = function (max) {
        var res = enforceQuantityLimit(max, true);
        if (res && res.clamped) {
          setNote("Sorry, we don't have that many available right now.");
        } else if (res && !res.clamped && isShortageNoteActive()) {
          setNote('');
        }
      };
      if (maxKnown) {
        maybeClamp(maxAttr);
      } else {
        clampToLiveMax(true).then(maybeClamp);
      }
    });

    // Also enforce on blur to catch paste events
    qtyInput.addEventListener('blur', function () {
      if (qtyInput.disabled) return;
      var maxAttr = qtyInput.hasAttribute('max') ? Number(qtyInput.getAttribute('max')) : getCurrentVariantMax();
      if (typeof maxAttr === 'number' && !isNaN(maxAttr)) {
        var res = enforceQuantityLimit(maxAttr, true);
        if (res && !res.clamped && isShortageNoteActive()) {
          setNote('');
        }
      } else {
        clampToLiveMax(true);
      }
    });
  }

  if (qtyMinus) {
    qtyMinus.addEventListener('click', function () {
      if (qtyInput && qtyInput.disabled) return;
      clampToLiveMax(false).then(function (max) {
        bumpQuantity(-1, false, max);
        if (isShortageNoteActive()) {
          setNote('');
        }
      });
    });
  }

  if (qtyPlus) {
    qtyPlus.addEventListener('click', function () {
      if (qtyInput && qtyInput.disabled) return;
      clampToLiveMax(true).then(function (max) {
        bumpQuantity(1, true, max);
      });
    });
  }

  if (form) {
    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      var getMax = function () {
        if (!qtyInput) return Promise.resolve(null);
        var maxAttr = qtyInput.hasAttribute('max') ? Number(qtyInput.getAttribute('max')) : getCurrentVariantMax();
        if (typeof maxAttr === 'number' && !isNaN(maxAttr)) return Promise.resolve(maxAttr);
        return clampToLiveMax(true);
      };

      getMax().then(function (max) {
        var res = enforceQuantityLimit(max, true);
        if (res && res.clamped) {
          setNote("Sorry, we don't have that many available right now.");
          return;
        }

        var id = variantInput ? Number(variantInput.value || 0) : 0;
        var qty = qtyInput ? Number(qtyInput.value || 1) : 1;
        if (!id) {
          setNote('Select options to see availability.');
          return;
        }

        if (addButton) addButton.disabled = true;
        setNote('');

        // Check cart for existing quantity of this variant
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) {
            if (!r.ok) throw new Error('cart fetch failed');
            return r.json();
          })
          .then(function (cart) {
            var existingQty = 0;
            if (cart.items && Array.isArray(cart.items)) {
              cart.items.forEach(function (item) {
                if (Number(item.variant_id) === id) {
                  existingQty += Number(item.quantity || 0);
                }
              });
            }

            var totalQty = existingQty + qty;
            if (typeof max === 'number' && !isNaN(max) && totalQty > max) {
              if (addButton) addButton.disabled = false;
              var remaining = Math.max(0, max - existingQty);
              if (remaining > 0) {
                setNote("Sorry, we only have " + remaining + " more available (you already have " + existingQty + " in your bag).");
              } else {
                setNote("Sorry, you already have the maximum available in your bag.");
              }
              return;
            }

            // Proceed with adding to cart
            var payload = { id: id, quantity: qty };

            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify(payload)
            })
              .then(function (r) {
                if (!r.ok) throw new Error('add failed');
                return r.json();
              })
              .then(function (added) {
                if (addButton) addButton.disabled = false;
                refreshCartCountBestEffort();
                dispatchCartEvents({ source: 'product-page', added: added });
                openCartDrawerBestEffort();
              });
          })
          .catch(function () {
            if (addButton) addButton.disabled = false;
            setNote("Sorry, we couldn't add to bag.");
          });
      });
    });
  } else if (addButton) {
    addButton.addEventListener('click', function () {
      var max = qtyInput && qtyInput.hasAttribute('max')
        ? Number(qtyInput.getAttribute('max'))
        : getCurrentVariantMax();
      var res = enforceQuantityLimit(max, true);
      if (res && res.clamped) {
        setNote("Sorry, we don't have that many available right now.");
      }
    });
  }

  // --- NEW: Thumbnail Scroller ---
  var thumbsWrapper = section.querySelector('.product-gallery__thumbs-wrapper');
  if (thumbsWrapper) {
    var thumbsContainer = thumbsWrapper.querySelector('[data-product-thumbs]');
    var scrollUpBtn = thumbsWrapper.querySelector('[data-thumb-scroll-up]');
    var scrollDownBtn = thumbsWrapper.querySelector('[data-thumb-scroll-down]');

    var checkThumbScroll = function() {
      if (!thumbsContainer || !scrollUpBtn || !scrollDownBtn) return;
      
      // Use a small timeout to allow the DOM to settle after image loads
      setTimeout(function() {
        var hasOverflow = thumbsContainer.scrollHeight > thumbsContainer.clientHeight;
        
        if (!hasOverflow) {
          scrollUpBtn.hidden = true;
          scrollDownBtn.hidden = true;
          return;
        }

        var atTop = thumbsContainer.scrollTop < 1;
        var atBottom = Math.abs(thumbsContainer.scrollHeight - thumbsContainer.clientHeight - thumbsContainer.scrollTop) < 1;

        scrollUpBtn.hidden = atTop;
        scrollDownBtn.hidden = atBottom;
      }, 50);
    };

    if (thumbsContainer) {
      thumbsContainer.addEventListener('scroll', checkThumbScroll, { passive: true });

      // Observe for changes in the number of thumbs
      var observer = new MutationObserver(checkThumbScroll);
      observer.observe(thumbsContainer, { childList: true });
    }

    if (scrollUpBtn) {
      scrollUpBtn.addEventListener('click', function() {
        if (!thumbsContainer) return;
        // Scroll by approx 2 thumb heights
        var scrollAmount = thumbsContainer.clientHeight * 0.75;
        thumbsContainer.scrollBy({ top: -scrollAmount, behavior: 'smooth' });
      });
    }

    if (scrollDownBtn) {
      scrollDownBtn.addEventListener('click', function() {
        if (!thumbsContainer) return;
        // Scroll by approx 2 thumb heights
        var scrollAmount = thumbsContainer.clientHeight * 0.75;
        thumbsContainer.scrollBy({ top: scrollAmount, behavior: 'smooth' });
      });
    }

    // Initial check
    checkThumbScroll();
    // Another check after images have likely loaded
    window.addEventListener('load', checkThumbScroll);
  }
});

// ========================================
// Size Guide Modal
// ========================================
document.addEventListener('DOMContentLoaded', function () {
  var dialog = document.querySelector('#SizeGuideDialog');
  var backdrop = document.querySelector('[data-size-guide-backdrop]');
  var trigger = document.querySelector('[data-size-guide-trigger]');
  var closeBtn = document.querySelector('[data-size-guide-close]');

  if (!dialog || !backdrop || !trigger) return;

  function openBackdrop() {
    backdrop.hidden = false;
  }

  function closeBackdrop() {
    backdrop.hidden = true;
  }

  function openDialog() {
    openBackdrop();
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', 'open');
    }
  }

  function closeDialog() {
    if (dialog.open && typeof dialog.close === 'function') dialog.close();
    dialog.removeAttribute('open');
    closeBackdrop();
  }

  // Open on trigger click
  trigger.addEventListener('click', function (e) {
    e.preventDefault();
    openDialog();
  });

  // Close on close button click
  if (closeBtn) {
    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      closeDialog();
    });
  }

  // Close on backdrop click
  backdrop.addEventListener('click', function () {
    closeDialog();
  });

  // Also close when clicking outside the dialog content
  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) closeDialog();
  });

  // Close on ESC key
  dialog.addEventListener('cancel', function (e) {
    e.preventDefault();
    closeDialog();
  });
});

// ========================================
// Product Accordion - Close others when opening one
// ========================================
document.addEventListener('DOMContentLoaded', function () {
  var accordions = Array.prototype.slice.call(
    document.querySelectorAll('.product-accordion')
  );

  if (!accordions.length) return;

  accordions.forEach(function (accordion) {
    accordion.addEventListener('toggle', function () {
      if (accordion.open) {
        accordions.forEach(function (other) {
          if (other !== accordion && other.open) {
            other.open = false;
          }
        });
      }
    });
  });
});